const productInfo = {
  P060027: "microEnterprisesReassure", //安心保，意健险
  P060026: "microEnterprisesSafe", //雇主安心保（2010升级版）
  P060017: "microEnterprisesExempt", //小微免核雇主
  P060028: "microAmazon", //小微亚马逊平台商业综合保险产品
  P060030: "mGoodEnterpriseNet", //小微企业保-互联网版
  P060029: "microEnterpriseShanghai", //雇主安心保-上海直通
  P060031: "microMotionNationwide", // 直通专属运动无忧2.0 (全国版)
  P060032: "microMoveNationwide", // 直通专属活动无忧(全国版)
  P060033: "microTrainNationwide", // 直通专属训练无忧(全国版)
  P060034: "microEnterprisesSafeJF", // 雇主安心保(洛阳JF)
  P060035: "microShangPuFu", // 小微商品福
  P060036: "microEnterpriseFinancialSecurityJF", // 河南直通专属企财安心保
  P060037: "microZhuangXiuFu", // 小微装修福
  P060038: "microZhuangXiuBao", // 装修保-直通专属版
  P060039: "microEnterpriseOnline", // 企业安心保（互联网版）
  // P060088: "microECommerceFree", // 1688电商保赠险
  P060089: "microECommerce", // 1688电商保商险
  P060090: "microECommerceSingleFree", // 1688电商保商险赠险
  P060091: "microECommerceSingle", // 1688电商保商险商险
  P040032: "groupComprehensiveAccident", // 原来的名字"teamAccidentInsurance",
  P040033: "teamShortTermAccident",
  P040034: "teamShortTermAccidentA",
  P040035: "teamShortTermAccidentB",
  P040036: "teamShortTermAccidentC",
  P060092: "microECommerceNew", // 1688电商保商险商险
};
//当前打包的产品代码，如果需要打包其他产品，请更换产品代码
//buildall.js 中关联了productCode正则  /"P0600[0-9]{2}|P040032"/，需要维护这个正则
const currentProductCode = "P060027";
const currentProductName = productInfo[currentProductCode];

module.exports = { currentProductCode, currentProductName, productInfo};
//export {currentProductCode,currentProductName}
//访问目录
//http://dmzstg1.pa18.com/pa18shopnst/mProduct/${currentProductName}/index.html#/
